import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CALENDARIO_ESPANOL } from '../core/_util/fechas';
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { EjecutarConsultaComponent } from '../ejecutar-consulta/ejecutar-consulta.component';
import { listaSiNo } from '../core/_util/listas-utils';
import { listaPresentacion, listaTipoDato } from '../core/_util/columnas-utils';

@Component({
  selector: 'app-consultas',
  templateUrl: './consultas.component.html',
  styleUrls: ['./consultas.component.scss']
})
export class ConsultasComponent implements OnInit {

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;
  botonGuardar: Boolean = false;
  botonActualizar: Boolean = false;
  mostrarEstado: Boolean = false;
  cargandoListaConsultas: boolean = true;
  idConsulta: any;

  // Filtro
  formularioFiltro: FormGroup;
  cargandoPagina: boolean = false;
  filtro: Boolean = true;

  //lista de registros
  registrosLista: any = [];
  registrosListaActiva: any[] = [];
  listaEstado: any = [];
  columnas: any = [];
  totalRecords = 0;
  crear: any = '';

  ejecutarConsulta: any = false;
  consultas: any[] = [];
  consultasActivas: any[] = [];
  consultaSeleccionada: any;

  // Columnas
  formularioColumna: FormGroup;
  editarConsulta: Boolean = false;
  botonEditar: Boolean = false;
  mostrarFormularioColumna: Boolean = false;
  verColumna: Boolean = false;
  columnasDetalle: any[] = [];
  registrosColumnas: any[] = [];
  totalRecordsColumnas = 0;
  mostrar = listaSiNo;
  tipoPresentacion = listaPresentacion;
  tipoDato = listaTipoDato;
  idColumna: any;
  idCabecera: any;

  pageSize: Number = 5;
  paginationOptions = {
    pageNumber: 1,
    rows: this.pageSize,
    pageLinkSize: 3,
    rowsPerPageOptions: [this.pageSize, 10, 15],
    totalRecords: 0
  };

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService
  ) {
    this.breadCrumbService.setItems([
      { label: 'Consultas' }
    ]);

    this.formBuilder = new FormBuilder();

    this.listaEstado = [
      { descripcion: 'ACTIVO', id: 'ACTIVO' },
      { descripcion: 'INACTIVO', id: 'INACTIVO' }
    ];
  }

  ngOnInit(): void {

    if (this.route.snapshot) {
      this.crear = this.route.snapshot;
    }

    this.totalRecords = 0;
    this.columnas = [
      { field: 'programa', header: 'Programa' },
      { field: 'titulo', header: 'Titulo' },
      { field: 'estado', header: 'Estado' },
    ];
    this.columnasDetalle = [
      { header: 'Columna', field: 'columna' },
      { header: 'Etiqueta', field: 'etiqueta' },
      { header: 'Tipo de Dato', field: 'tipo_dato' },
      { header: '¿Mostrar?', field: 'mostrar' },
    ];
    this.formulario = this.formBuilder.group({
      programa: ['', Validators.required],
      titulo: ['', Validators.required],
      subtitulo: [''],
      observaciones: [''],
      estado: [''],
      estado1: [''],
    });
    this.formularioColumna = this.formBuilder.group({
      columna: ['', Validators.required],
      longitud: ['', Validators.required],
      etiqueta: ['', Validators.required],
      orden: ['', Validators.required],
      inicial: [],
      mostrar: ['', Validators.required],
      filtrar: ['', Validators.required],
      presentacion: [],
      dato: [],
      obligatorio: [],
      datosLista: [],
    });

    this.formularioFiltro = this.formBuilder.group({
      programa: [],
      titulo: [],
    })
    this.getListado();
  }

  /**
   * Listados
   */
  getListado() {
    this.cargandoListaConsultas = true;
    this.coreService.get('/cabecera-consulta').subscribe(
      (res: any[]) => {
        this.registrosLista = res;
        this.totalRecords = this.registrosLista.length;

        this.registrosLista.forEach(element => {
          this.consultas.push({ label: element.titulo, value: element.id });
        });

        this.cargandoListaConsultas = false;

      },
      (err: any) => {
        this.cargandoListaConsultas = false;
        console.log(err);
      }
    )
  }

    /**
   * Listados
   */
     getListadoConsultaActiva() {
      this.cargandoListaConsultas = true;
      this.coreService.get('/cabecera-consulta-activa').subscribe(
        (res: any[]) => {
          this.registrosListaActiva = res;
          this.registrosListaActiva.forEach(element => {
            this.consultasActivas.push({ label: element.titulo + ' (' + element.programa + ')', value: element.id });
          });
  
          this.cargandoListaConsultas = false;
  
        },
        (err: any) => {
          this.cargandoListaConsultas = false;
          console.log(err);
        }
      )
    }

  /**
   * Acciones
   */
  prepararNuevo() {
    this.mostrarFormulario = true;
    this.registroNuevo = true;
    this.formulario.reset();
    this.botonGuardar = true;
    this.botonActualizar = false;
    this.mostrarEstado = false;
    this.filtro = false;
    this.formulario.controls['estado1'].setValue('ACTIVO');
  }

  volver() {
    this.mostrarFormulario = false;
    this.submitted = false;
    this.filtro = true;
  }

  /**
   * Crear
   */
  guardar() {
    var dat = this.formulario.valid;
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar esta consulta?',
        accept: () => {
          this.submitted = true;
          this.postGuardarConsulta();
          this.mostrarFormulario = false;
        }
      });
    } else {
      this.formulario.markAllAsTouched();
    }
  }

  postGuardarConsulta() {
    let params = {
      programa: this.formulario.value.programa,
      titulo: this.formulario.value.titulo,
      subtitulo: this.formulario.value.subtitulo,
      estado: 'ACTIVO',
      observaciones: this.formulario.value.observaciones
    };

    this.coreService.post('/crear-cabecera-consulta', params).subscribe(
      (res: any[]) => {
        this.msj.info('Consulta Guardada Correctamente');
        this.filtro = true;
        this.getListado();
      },
      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }

  /**
   * Actualizar
   */
  editar(data) {
    this.idConsulta = data.id;
    this.registroNuevo = false;
    this.mostrarFormulario = true;
    this.botonGuardar = false;
    this.botonActualizar = true;
    this.mostrarEstado = true;
    this.filtro = false;
    this.formulario.controls['programa'].setValue(data.programa);
    this.formulario.controls['titulo'].setValue(data.titulo);
    this.formulario.controls['subtitulo'].setValue(data.subtitulo);
    this.formulario.controls['observaciones'].setValue(data.observaciones);
    this.formulario.controls['estado'].setValue(this.cargarListaEstado(this.listaEstado, data.estado));
  }

  cargarListaEstado(iLista, valor) {
    if (iLista !== undefined && iLista != null) {
      for (let i = 0; i < iLista.length; i++) {
        if (iLista[i].id === valor) {
          return iLista[i];
        }
      }
    }
  }

  actualizar() {
    let dat = this.formulario.valid;
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea actualizar esta consulta?',
        accept: () => {
          this.formulario.markAllAsTouched();
          this.submitted = true;
          this.putActualizarFamiliar();
          this.mostrarFormulario = false;
        }
      });
    } else {
      this.formulario.markAllAsTouched();
    }
  }

  putActualizarFamiliar() {
    const formato = 'yyyy-MM-dd';
    const localizacion = 'en-US';

    let params = {
      id: this.idConsulta,
      programa: this.formulario.value.programa,
      titulo: this.formulario.value.titulo,
      subtitulo: this.formulario.value.subtitulo,
      observaciones: this.formulario.value.observaciones,
      estado: this.formulario.value.estado.id
    }

    this.coreService.put('/editar-cabecera-consulta', params).subscribe(
      (res: any[]) => {
        this.msj.info("Consulta actualizada exitosamente");
        this.filtro = true;
        this.getListado();
      },

      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }

  /**
   * Eliminar
   */
  eliminar(id) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar esta consulta?',
      accept: () => {
        this.submitted = true;
        this.deleteConsulta(id);
      }
    });
  }

  deleteConsulta(id) {
    this.coreService.delete('/eliminar-cabecera-consulta', id).subscribe(
      (res: any[]) => {
        this.msj.info('Se eliminó correctamente la consulta');
        this.getListado();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  /**
   * Validaciones
   */
  mayusculaPrg(e) {
    if (e.target.value !== null) {
      this.formulario.controls['programa'].setValue(e.target.value.toUpperCase());
    }
  }

  mayusculaTi(e) {
    if (e.target.value !== null) {
      this.formulario.controls['titulo'].setValue(e.target.value.toUpperCase());
    }
  }

  mayusculaSub(e) {
    if (e.target.value !== null) {
      this.formulario.controls['subtitulo'].setValue(e.target.value.toUpperCase());
    }
  }

  mayusculaObs(e) {
    if (e.target.value !== null) {
      this.formulario.controls['observaciones'].setValue(e.target.value.toUpperCase());
    }
  }

  campoNoValido(campo: any) {
    return this.formulario.get(campo)?.invalid && this.formulario.get(campo)?.touched;
  }

  cambiarEjecutarConsulta() {
    this.getListadoConsultaActiva();
    this.ejecutarConsulta = true;
    this.filtro = false;
  }

  volverTabla() {
    this.ejecutarConsulta = false;
    this.filtro = true;
  }

  // Apartado Columnas

  volverACabecera() {
    this.verColumna = false;
  }

  verColumnas(data) {
    this.idCabecera = data.id;
    this.verColumna = true;
    this.getListadoColumnasxConsulta(this.idCabecera);
  }

  cargarDatosEditar(iLista, valor) {

    if (iLista !== undefined && iLista != null) {
      for (let i = 0; i < iLista.length; i++) {
        if (iLista[i].value === valor) {
          return iLista[i];
        }
      }
    }
  }

  prepararNuevaColumna() {

    this.formularioColumna.reset();
    this.editarConsulta = true;
    this.mostrarFormularioColumna = true;
    this.botonEditar = false;
    this.botonGuardar = true;
  }

  editarColumna(data) {
    this.editarConsulta = true;
    this.cargarConsulta(data);
    this.mostrarFormularioColumna = true;
    this.botonEditar = true;
    this.botonGuardar = false;
    this.idColumna = data.id;
  }

  cargarConsulta(data) {
    this.idCabecera = data.cabecerra_id;
    this.formularioColumna.controls['columna'].setValue(data.columna);
    this.formularioColumna.controls['longitud'].setValue(data.longitud);
    this.formularioColumna.controls['etiqueta'].setValue(data.etiqueta);
    this.formularioColumna.controls['orden'].setValue(data.orden);
    this.formularioColumna.controls['inicial'].setValue(data.valor_defecto);
    this.formularioColumna.controls['mostrar'].setValue(this.cargarDatosEditar(this.mostrar, data.mostrar));
    this.formularioColumna.controls['filtrar'].setValue(this.cargarDatosEditar(this.mostrar, data.permitir_filtrar));
    this.formularioColumna.controls['presentacion'].setValue(this.cargarDatosEditar(this.tipoPresentacion, data.tipo_presentacion));
    this.formularioColumna.controls['dato'].setValue(this.cargarDatosEditar(this.tipoDato, data.tipo_dato));
    this.formularioColumna.controls['obligatorio'].setValue(this.cargarDatosEditar(this.mostrar, data.solicitar_obligatorio));
    this.formularioColumna.controls['datosLista'].setValue(data.consulta_datos);
  }

  actualizarColumna() {

    let dat = this.formularioColumna.valid;

    if (dat) {

      this.confirmationService.confirm({
        message: '¿Desea actualizar este registro?',
        accept: () => {
          this.formularioColumna.markAllAsTouched();
          this.putActualizarColumna();

        }
      });
    } else {
      this.formulario.markAllAsTouched();
    }
  }

  putActualizarColumna() {

    let params = {
      id: this.idColumna,
      cabecerra_id: this.idCabecera,
      columna: this.formularioColumna.value.columna.toUpperCase(),
      longitud: this.formularioColumna.value.longitud,
      etiqueta: this.formularioColumna.value.etiqueta.toUpperCase(),
      orden: this.formularioColumna.value.orden,
      valor_defecto: this.formularioColumna.value.inicial,
      mostrar: this.formularioColumna.value.mostrar.value,
      permitir_filtrar: this.formularioColumna.value.filtrar.value,
      tipo_presentacion: this.formularioColumna.value.filtrar.value == 1 ? (this.formularioColumna.value.presentacion ? this.formularioColumna.value.presentacion.value : null) : null,
      tipo_dato: this.formularioColumna.value.filtrar.value == 1 ? (this.formularioColumna.value.dato ? this.formularioColumna.value.dato.value : null) : null,
      solicitar_obligatorio: this.formularioColumna.value.filtrar.value == 1 ? (this.formularioColumna.value.obligatorio ? this.formularioColumna.value.obligatorio.value : null) : null,
      consulta_datos: this.formularioColumna.value.filtrar.value == 1 ? (this.formularioColumna.value.datosLista ? this.formularioColumna.value.datosLista.toUpperCase() : null) : null,
    }
    this.coreService.put('/editar-detalle-columna', params).subscribe(
      (res: any[]) => {
        this.msj.info("Columna Modificada.");
        this.getListadoColumnasxConsulta(params.cabecerra_id);
        this.mostrarFormularioColumna = false;
        this.editarConsulta = false;
      },

      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }
  volverAgregar() {
    this.editarConsulta = false;
    this.botonEditar = false;
    this.mostrarFormularioColumna = false;
  }

  getListadoColumnasxConsulta(id) {
    let params = {
      cabecera_id: id,
    }
    this.idCabecera = params.cabecera_id;
    this.coreService.getWithParams('/columna-consulta', params).subscribe(
      (res: any[]) => {
        this.registrosColumnas = res;
        this.totalRecordsColumnas = res.length;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  labelMostrar(id) {
    let label = '';
    this.mostrar.forEach(element => {
      if (element.value == id) {
        label = element.label;
      }
    }
    );
    return label;
  }

  guardarColumna() {

    let data = this.formularioColumna.valid;
    if (data) {

      this.confirmationService.confirm({
        message: '¿Desea guardar este registro?',
        accept: () => {
          this.formularioColumna.markAllAsTouched();
          this.postGuardarColumna();
        }
      });
    } else {
      this.formularioColumna.markAllAsTouched();
    }
  }

  postGuardarColumna() {
    let params = {
      cabecerra_id: this.idCabecera,
      columna: this.formularioColumna.value.columna.toUpperCase(),
      longitud: this.formularioColumna.value.longitud,
      etiqueta: this.formularioColumna.value.etiqueta.toUpperCase(),
      orden: this.formularioColumna.value.orden,
      valor_defecto: this.formularioColumna.value.inicial,
      mostrar: this.formularioColumna.value.mostrar.value,
      permitir_filtrar: this.formularioColumna.value.filtrar.value,
      tipo_presentacion: this.formularioColumna.value.presentacion ? this.formularioColumna.value.presentacion.value : null,
      tipo_dato: this.formularioColumna.value.dato ? this.formularioColumna.value.dato.value : null,
      solicitar_obligatorio: this.formularioColumna.value.obligatorio ? this.formularioColumna.value.obligatorio.value : null,
      consulta_datos: this.formularioColumna.value.datosLista ? this.formularioColumna.value.datosLista.toUpperCase() : null,
    }

    this.coreService.post('/crear-columna-consulta', params).subscribe(
      (res: any[]) => {
        this.mostrarFormularioColumna = false;
        this.editarConsulta = false;
        this.getListadoColumnasxConsulta(params.cabecerra_id);
        this.msj.info("Columna Guardada.");
      },

      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }

  eliminarColumna(id) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar esta consulta?',
      accept: () => {
        this.submitted = true;
        this.deleteColumna(id);
      }
    });
  }

  deleteColumna(id) {
    this.coreService.delete('/eliminar-columna-consulta', id).subscribe(
      (res: any[]) => {
        this.msj.info('Se eliminó correctamente la columna');
        this.getListadoColumnasxConsulta(this.idCabecera);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  filtrar() {
    this.cargandoPagina = true;

    let params = {
      page: this.paginationOptions.pageNumber,
      size: this.paginationOptions.rows,
    };

    if (this.formularioFiltro.value.programa !== undefined && this.formularioFiltro.value.programa !== null && this.formularioFiltro.value.programa !== '') {
      params['programa'] = this.formularioFiltro.value.programa.toUpperCase();
      params.page = 1;
    }

    if (this.formularioFiltro.value.titulo !== undefined && this.formularioFiltro.value.titulo !== null && this.formularioFiltro.value.titulo !== '') {
      params['titulo'] = this.formularioFiltro.value.titulo.toUpperCase();
      params.page = 1;
    }

    this.coreService.getWithParams('/filtro', params).subscribe(
      (res: any) => {
        this.registrosLista = res.data;

        this.cargandoListaConsultas = false;
        this.paginationOptions.totalRecords = res.total;

      },
      (err: any) => {
        console.log(err);
        this.registrosLista = [];
        this.paginationOptions.totalRecords = 0;
        this.cargandoListaConsultas = false;
      }
    );
  }

  cambioPagina(event) {
    this.paginationOptions.rows = event.rows;
    this.paginationOptions.pageNumber = (event.first / event.rows) + 1;
    this.filtrar();
  }
}